import React, { Component } from "react";

import {
  Form,
  Select,
  Button,
  Input,
  DatePicker,
  Checkbox,
  Row,
  Col,
  Modal,
  Spin,
  Space,
} from "antd";

import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import WareHouseStore from "../store/WareHouseStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import Autocomplete from "react-google-autocomplete";
import config from "../config";
import dayjs from "dayjs";
import DisplayLocationMap from "./DisplayLocationMap";
import { CloseOutlined } from "@ant-design/icons";
import CountryStore from "../store/CountryStore";
const { Option } = Select;

class WarehouseAdd extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      companyId: "",
      loadList: 0,
      search: false,
      warehouseId: -1,
      offset: 0,
      limit: 50,
      addressInfo: [],
      addressMap: false,
      update: 0,
      errorShow: false,
      loadingSpin: false,
    };
    this.wareHouseStore = new WareHouseStore();
    this.companyStore = new CompanyStore(this);
    this.countryStore = new CountryStore(this);
  }

  async componentDidMount() {
    await this.countryStore.getCountry();

    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setWarehouseStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      // await this.setState({userId:this.props.getUserData().userId})
      // await this.setState({isadmin:this.props.getUserData().isadmin})
    }
    const companyId = this.props.companyId;
    const vehicleId = this.props.vehicleId;

    if (vehicleId) {
      await this.setState({ loadingSpin: true });
      const getWarehouse = await this.wareHouseStore.getWareHouse({
        wid: vehicleId,
        companyId: companyId,
      });

      console.log(getWarehouse, "getWarehouse");

      await this.setState({
        companyId: getWarehouse.companyId,
        warehouseId: getWarehouse.id,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        getWarehouse.companyId
      );

      await this.formRef.current.setFieldsValue({
        companyId: singleData,
        wname: getWarehouse.warehouse,
        city: getWarehouse.city,
        address: getWarehouse.address,
        longitude: getWarehouse.longitude,
        latitude: getWarehouse.latitude,
        landcordinate: getWarehouse.landCoordinates,
        licenseno: getWarehouse.licenseNo,
        issueDate: getWarehouse.licenseIssueDate
          ? dayjs(getWarehouse.licenseIssueDate)
          : null,

        expiryDate: getWarehouse.licenseExpiryDate
          ? dayjs(getWarehouse.licenseExpiryDate)
          : null,
        Phone: getWarehouse.phone,
        managermobno: getWarehouse.managerMobile,
        email: getWarehouse.email,
        landarea: getWarehouse.landArea,
        countryCode: getWarehouse.countryCode,
        managermobnoCountryCode: getWarehouse.managermobnoCountryCode,
      });

      await this.setState({ loadingSpin: false });
    }
    this.setState({ loadData: 1 });
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.addressMap &&
      prevState.addressMap !== this.state.addressMap
    ) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }

  onWarehouseDetailsSubmit = async (values) => {
    this.setState({ loading: true });

    const data = {
      ...values,
      companyId: this.state.companyId,
      warehouseId: this.state.warehouseId,

      issueDate: values.issueDate
        ? values.issueDate.format("YYYY-MM-DD")
        : null,
      expiryDate: values.issueDate
        ? values.expiryDate.format("YYYY-MM-DD")
        : null,
    };

    const response = await this.wareHouseStore.addData(data);
    this.props.response(response);
    // if (response?.success === "S") {
    //   message.success("Warehouse Details Saved");
    //   this.props.navigate("/warehouselist");
    // } else {
    //   message.error(response.message);
    // }
    this.setState({ loading: false });
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleId) {
      this.context.viewStateStore.setWarehouseStates({ companyId: comp.value });
    }

    await this.setState({ companyId: comp.value });
    await this.formRef.current.setFieldsValue({
      companyId: this.state.companyId,
    });
    await this.handleSearch();
  }

  async handleSearch() {
    await this.wareHouseStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  validateNumber = (value, field1) => {
    // Check if value contains only numbers
    // const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field1]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field1]: "" });
    }
  };
  validateFieldsValue = (value, field) => {
    // Check if value contains only numbers
    // const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9.]*/g, "");

    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };
  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            wrapperClassName="spinClass"
            spinning={this.state.loadingSpin}
            fullscreen
          >
            <Form
              ref={this.formRef}
              layout="vertical"
              onFinish={this.onWarehouseDetailsSubmit}
              onFinishFailed={(e) => this.setState({ errorShow: true })}
              name="nest-message"
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      className="uploadCompany"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_ACCOUNT_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <CompanyAutocomplete
                        onChange={(value) => this.handleChange(value)}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    name="wname"
                    // label={this.context.translate("_NAME_WAREHOUSE_")}
                    // rules={[{ required: true }]}
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_NAME_WAREHOUSE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_NAME_WAREHOUSE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="city"
                    // label={this.context.translate("_CITY_OF_WAREHOUSE_")}
                    // rules={[{ required: true }]}
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_CITY_OF_WAREHOUSE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_CITY_OF_WAREHOUSE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="address"
                    // label={this.context.translate("_ADDRESS_OF_WAREHOUSE_")}
                    // rules={[{ required: true }]}
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_ADDRESS_OF_WAREHOUSE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ADDRESS_OF_WAREHOUSE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    // label={this.context.translate("_PHONE_")}
                    label={
                      <span>
                        {this.context.translate("_PHONE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_PHONE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        name="countryCode"
                        noStyle
                        initialValue={config.countryCode}
                      >
                        <Select style={{ width: "55%", borderRadius: "5px" }}>
                          {this.countryStore?.country?.map((country) => {
                            return (
                              <Option
                                key={country.countryId}
                                value={parseInt(country.countryId)}
                              >
                                {country.countryCode}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="Phone"
                        noStyle
                        rules={[
                          {
                            required: true,
                            pattern: /^\d{8,10}$/,
                            // message: "Enter a 7 or 10 digit number",
                            message: this.context.translate(
                              "_Enter_7_or_10_Digit_Number_"
                            ),
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          onChange={(e) =>
                            this.validateNumber(e.target.value, "Phone")
                          }
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  <Form.Item className="uploadCompany" name="select" label=" ">
                    <Checkbox
                      checked={this.state.search}
                      onChange={(e) => {
                        this.setState({ search: e.target.checked });
                      }}
                    >
                      {this.context.translate("_SELECT_FROM_MAP")}
                    </Checkbox>
                  </Form.Item>

                  {this.state.search && (
                    <Form.Item
                      className="uploadCompany"
                      name="searchAddress"
                      label={this.context.translate("_SEARCH_ADDRESS_")}
                    >
                      <Autocomplete
                        style={{
                          width: "100%",
                          height: "40px",
                          boxShadow: "none",
                          padding: "4px 11px",
                          borderWidth: 1,
                          borderStyle: "solid",
                          borderColor: "#d9d9d9",
                          borderRadius: "6px",
                        }}
                        // apiKey={"AIzaSyAu2h2n_gORgPafUoADJBdEuyjN-zlr8VM"}
                        apiKey={config.googleMapKey}
                        onPlaceSelected={async (place) => {
                          await this.formRef.current.setFieldsValue({
                            searchAddress: place.formatted_address,
                            latitude: place.geometry.location.lat(),
                            longitude: place.geometry.location.lng(),
                          });
                          await this.setState({ addressMap: true });
                          await this.setState({
                            addressInfo: [
                              place.geometry.location.lat(),
                              place.geometry.location.lng(),
                            ],
                          });
                        }}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    name="latitude"
                    label={this.context.translate(
                      "_FLEET_DASHBORD_SETTING_LATITUDE_"
                    )}
                    className="uploadCompany"
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    name="longitude"
                    label={this.context.translate(
                      "_FLEET_DASHBORD_SETTING_LONGITUDE_"
                    )}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    name="landcordinate"
                    label={this.context.translate("_LAND_CORDINATES_")}
                  >
                    <Autocomplete
                      style={{
                        width: "100%",
                        height: "40px",
                        boxShadow: "none",
                        padding: "4px 11px",
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: "#d9d9d9",
                        borderRadius: "6px",
                      }}
                      placeholder="e.g lat1:long1,lat2:long2,lat3:long3,lat4:long4"
                      apiKey={config.googleMapKey}
                      onPlaceSelected={async (place) => {
                        await this.formRef.current.setFieldsValue({
                          landcordinate: place.formatted_address,
                          // latitude: place.geometry.location.lat(),
                          // longitude: place.geometry.location.lng(),
                        });
                        await this.setState({ addressMap: true });
                        await this.setState({
                          addressInfo: [
                            place.geometry.location.lat(),
                            place.geometry.location.lng(),
                          ],
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="licenseno"
                    // label={this.context.translate("_LICENSE_NUMBER_")}
                    // rules={[{ required: true }]}
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_LICENSE_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_LICENSE_NUMBER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="issueDate"
                    // label={this.context.translate("_LICENSE_ISSUE_DATE_")}
                    // rules={[{ required: true }]}
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_LICENSE_ISSUE_DATE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_LICENSE_ISSUE_DATE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px" }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>

                  <Form.Item
                    name="expiryDate"
                    className="uploadCompany"
                    // label={this.context.translate("_LICENSE_EXPIRY_DATE_")}
                    // rules={[{ required: true }]}
                    style={{ width: "100%" }}
                    label={
                      <span>
                        {this.context.translate("_LICENSE_EXPIRY_DATE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_LICENSE_EXPIRY_DATE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px" }}
                      format="YYYY-MM-DD"
                      disabledDate={(current) => {
                        return current && current < dayjs();
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    className="uploadCompany"
                    // label={this.context.translate("_WAREHOUSE_EMAIL_")}
                    // rules={[{ required: true, type: "email" }]}
                    label={
                      <span>
                        {this.context.translate("_WAREHOUSE_EMAIL_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WAREHOUSE_EMAIL_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_MANAGER_MOBILE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_MANAGER_MOBILE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        name="managermobnoCountryCode"
                        noStyle
                        initialValue={config.countryCode}
                      >
                        <Select style={{ width: "55%", borderRadius: "5px" }}>
                          {this.countryStore?.country?.map((country) => {
                            return (
                              <Option
                                key={country.countryId}
                                value={parseInt(country.countryId)}
                              >
                                {country.countryCode}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="managermobno"
                        noStyle
                        rules={[
                          {
                            required: true,
                            pattern: /^\d{8,10}$/,
                            // message: "Enter a 7 or 10 digit number",
                            message: this.context.translate(
                              "_Enter_7_or_10_Digit_Number_"
                            ),
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          onChange={(e) =>
                            this.validateNumber(e.target.value, "managermobno")
                          }
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    name="landarea"
                    // label={this.context.translate("_WAREHOUSE_LAND_AREA_")}
                    // rules={[{ required: true }]}
                    label={
                      <span>
                        {this.context.translate("_WAREHOUSE_LAND_AREA_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WAREHOUSE_LAND_AREA_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input
                      onChange={(e) => {
                        this.validateFieldsValue(e.target.value, "landarea");
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => {
                    this.closeModal();
                    this.setState({ search: false });
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button htmlType="submit" className="formsSaveButton">
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>

        {this.state.addressMap && (
          <Modal
            style={{ padding: "0px !important" }}
            className="multiTracking-popup"
            title={
              <div>
                Location On Map
                <CloseOutlined
                  onClick={() => this.setState({ addressMap: false })}
                />
              </div>
            }
            maskClosable={false}
            centered
            bodyStyle={{ height: "60vh", padding: "0px" }} // Adjust the dimensions as needed
            width={1000}
            open={this.state.addressMap}
            onCancel={() => this.setState({ addressMap: false })}
            footer={null}
          >
            <DisplayLocationMap
              addressInfo={
                this.state.addressInfo.length > 0 && this.state.addressInfo
              }
              formRef={this.formRef}
              address={(address) =>
                this.formRef.current.setFieldsValue({
                  searchAddress: address,
                  landcordinate: address,
                })
              }
            />
          </Modal>
        )}
      </div>
    );
  }
}

WarehouseAdd.contextType = StoreContext;
export default observer(withRouter(WarehouseAdd));
